// extracted by mini-css-extract-plugin
module.exports = {"forgotPass":"login_forgotPass__2v_tQ","orContainer":"login_orContainer__3q3CC","errorBlock":"login_errorBlock__1jPfq","forgotSuccess":"login_forgotSuccess__18cU8"};